/**
 * E11 web-portal design spec §1 — extracted from ConnectorJob.tsx's own
 * result block rather than left as a copy WebhookJob.tsx would
 * otherwise paste verbatim: both pages consume the identical
 * GeneratedConnector response shape (generate_connector and
 * generate_webhook's response bodies are byte-for-byte the same),
 * so the "ready / pricing line / one download button per file /
 * unresolved items" rendering belongs in one place, not two.
 */

import type { GeneratedConnector } from '../api/client';
import { downloadBlob } from '../lib/download';

function formatPence(pence: number): string {
  return `£${(pence / 100).toFixed(2)}`;
}

interface GeneratedFilesResultProps {
  result: GeneratedConnector;
}

export function GeneratedFilesResult({ result }: GeneratedFilesResultProps) {
  function downloadFile(path: string, content: string) {
    downloadBlob(new Blob([content], { type: 'text/x-python' }), path);
  }

  return (
    <div className="result">
      <p>Your generated code is ready ({result.files.length} file(s)).</p>
      <p className="muted small">
        {result.pricing.plan === 'free'
          ? `Free tier — no charge (${result.pricing.tier} complexity, ${result.pricing.model}).`
          : `Charged ${formatPence(result.pricing.price_charged_gbp_pence)} ` +
            `(${result.pricing.tier} complexity, ${result.pricing.model}).`}
      </p>
      {result.files.map((file) => (
        <button
          key={file.path}
          className="btn btn--primary"
          onClick={() => downloadFile(file.path, file.content)}
        >
          Download {file.path}
        </button>
      ))}
      {result.unresolved_operations.length > 0 && (
        <p className="muted small">
          Best-effort implementation, review before use: {result.unresolved_operations.join(', ')}
        </p>
      )}
    </div>
  );
}
